import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";
import { Controller } from "react-hook-form";
import { Checkbox } from "@material-ui/core";

function CustomTableCell(props) {
  return (
    <TableCell
      style={{
        paddingTop: 6,
        paddingBottom: 6,
        lineHeight: "1.1em",
        height: "48px",
      }}
      align={props.align}
      className={props.className}
    >
      {props.children}
    </TableCell>
  );
}

function NestedTableRow(props) {
  const { row, index, control, field } = props;
  return (
    <>
      {row.subRows.map((subRow, subRowIndex) => {
        const values = subRow.values;
        return (
          <TableRow key={`subRow-${subRowIndex}`}>
            <CustomTableCell scope="row" color="#333333">
              <SubdirectoryArrowRightIcon
                fontSize="small"
                style={{
                  color: "#CCCCCC",
                  marginRight: "10px",
                }}
              />
              {values.enTitle}
            </CustomTableCell>
            <CustomTableCell align="left" color="#333333">
              {values.tcTitle}
            </CustomTableCell>
            <CustomTableCell>
              <Controller
                defaultValue={
                  field[`${subRowIndex}`] && field[`${subRowIndex}`].visibility
                }
                control={control}
                name={`menu.${index}.subRows.${subRowIndex}.visibility`}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState,
                }) => {
                  return (
                    <Checkbox
                      color="primary"
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked);
                      }}
                      {...rest}
                    />
                  );
                }}
              />
            </CustomTableCell>
            <CustomTableCell>
              <Controller
                defaultValue={
                  field[`${subRowIndex}`] && field[`${subRowIndex}`].comingSoon
                }
                control={control}
                name={`menu.${index}.subRows.${subRowIndex}.comingSoon`}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState,
                }) => {
                  return (
                    <Checkbox
                      color="primary"
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked);
                      }}
                      {...rest}
                    />
                  );
                }}
              />
            </CustomTableCell>
            <CustomTableCell align="left" color="#333333">
              {values.slug}
            </CustomTableCell>
            <CustomTableCell align="right" color="#333333">
              {/* <Menu fontSize="small" style={{ color: "#CCCCCC" }} /> */}
            </CustomTableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export default NestedTableRow;
